<template>
    <div :style="homeMapContainerStyle">
        <div id="map" class="map">
            <div class="map-search" @mouseover="blockTooltip()">
                <!-- Pesquisa logo abaixo do menu -->
                <HomeMapControls
                    :controls="controls"
                    :user="user"
                    :cadastral-blocked="geoCadastralBlocked"
                    @change-modal="(val) => modalOpen = val"
                    @change-property="selectFeatureMapControlEvent"
                    @bic-closed="clearBicSelection"
                />
                <a-alert
                    v-if="geoCadastralWarning.show"
                    class="map-geo-cadastral-warning"
                    type="warning"
                    show-icon
                    banner
                >
                    <template #message>Dados cadastrais indisponíveis</template>
                    <template #description>{{ geoCadastralWarning.message }}</template>
                </a-alert>
            </div>

            <div class="map-layer-switch" @mouseover="blockTooltip()">
                <MapLayerSwitcher
                    :map="mapRef"
                    :disable-change="modalOpen"
                    v-if="!!mapRef"
                    :layer-switcher-data="layerSwitcherData"
                    @update-layer-data="layerSwitcherData = $event"
                />
            </div>

            <div class="map-controls" @mouseover="blockTooltip()">
                <ReturnToMobileApp />
                <!-- Ferramentas no canto inferior esquerdo -->
                <GeneralMapControls
                    v-if="!!mapRef"
                    :map="mapRef"
                    :swipe-permission="swipePermission"
                    @draw-start="() => isDrawing = true"
                    @draw-end="() => isDrawing = false"
                />
            </div>
            <div class="user-layers-config" @mouseover="blockTooltip()">
                <UserLayersConfig
                    v-if="!!mapRef"
                    :map="mapRef"
                    :layer-switcher-data="layerSwitcherData"
                    @apply-layer-config="layerSwitcherData = $event"
                />
            </div>

            <div ref="popupControl" class="map-popups" id="map-popups" @mouseover="blockTooltip()">
                <!-- Componentes de pop up (aparecem sobre o mapa sem posição fixa) devem ser colocados dentro desta div -->
                <div ref="tooltip" id="tooltip" class="map-tooltip"></div>
                <ModalsContainer :key="modalKey" />
                <HtmlModalMap ref="modalRef" @hide="closePopover"/>
                <HomeContextMenu :map="mapRef" v-if="!!mapRef" @reload-files="loadFileLayers" />

                <!-- Modal de arquivos -->
                <a-modal
                    v-model:open="modalFilesOpen"
                    title="Visualizar arquivos"
                    footer=""
                    width="90%"
                    style="max-width: 1100px; top: 4px"
                    :bodyStyle="{ maxHeight: 'calc(100vh - 90px)', overflowY: 'auto' }"
                    @afterOpenChange="onMapFilesModalAfterOpen"
                >
                    <div v-if="mapModalFileItems.length" class="map-files-carousel-wrap">
                        <div class="map-files-carousel-inner">
                            <a-button
                                v-if="mapModalFileItems.length > 1"
                                type="text"
                                class="map-files-carousel-arrow map-files-carousel-arrow-prev"
                                aria-label="Anterior"
                                @click="mapFilesCarouselPrev"
                            >
                                <i class="fas fa-chevron-left" aria-hidden="true"></i>
                            </a-button>
                            <a-carousel ref="mapFilesCarouselRef" effect="fade" class="map-files-carousel">
                                <div v-for="(item, index) in mapModalFileItems" :key="`${item.url}-${index}`" class="map-files-slide">
                                    <div class="map-files-slide-inner">
                                        <template v-if="isMapFileImageUrl(item.url)">
                                            <img
                                                :src="item.url"
                                                :alt="item.name"
                                                class="map-files-preview-img"
                                                @error="($e) => ($e.target.style.display = 'none')"
                                            />
                                        </template>
                                        <template v-else-if="isMapFilePdfUrl(item.url)">
                                            <embed v-if="item.url" :src="item.url" type="application/pdf" class="map-files-preview-pdf" />
                                        </template>
                                        <template v-else>
                                            <div class="map-files-file-card">
                                                <i class="fas fa-file-alt map-files-file-icon"></i>
                                                <span class="map-files-file-type">{{ mapFileTypeLabel(item.name) }}</span>
                                                <a-button type="primary" size="small" @click="openMapFileUrl(item.url)">
                                                    <i class="fas fa-external-link-alt"></i> Abrir em nova aba
                                                </a-button>
                                            </div>
                                        </template>
                                        <div class="map-files-slide-actions">
                                            <a :href="item.url" target="_blank" rel="noopener">{{ item.name }}</a>
                                            <a :href="item.url" :download="item.name">
                                                <a-button size="small" type="primary" :icon="h(DownloadOutlined)" />
                                            </a>
                                        </div>
                                    </div>
                                    <div class="map-files-slide-caption">
                                        {{ mapFileTypeLabel(item.name) }} ({{ index + 1 }}/{{ mapModalFileItems.length }})
                                    </div>
                                </div>
                            </a-carousel>
                            <a-button
                                v-if="mapModalFileItems.length > 1"
                                type="text"
                                class="map-files-carousel-arrow map-files-carousel-arrow-next"
                                aria-label="Próximo"
                                @click="mapFilesCarouselNext"
                            >
                                <i class="fas fa-chevron-right" aria-hidden="true"></i>
                            </a-button>
                        </div>
                    </div>
                    <div v-else class="map-files-empty">Nenhum arquivo neste ponto.</div>
                </a-modal>

                <!-- Modal Lote de Notificações (camadas Multifinalitário) -->
                <a-modal
                    v-model:open="notificationModalOpen"
                    title="Lote de Notificações"
                    :footer="null"
                    width="440px"
                    :maskClosable="true"
                    @cancel="closeNotificationModal"
                    @afterOpenChange="onNotificationModalOpenChange"
                >
                    <!-- Formulário: nova emissão -->
                    <template v-if="notificationView === 'form'">
                        <a-form layout="vertical">
                            <a-form-item label="Descrição do Lote de Notificações">
                                <a-textarea
                                    v-model:value="notificationDescription"
                                    :rows="4"
                                    placeholder="Descreva o lote de notificações..."
                                />
                            </a-form-item>
                            <div style="display: flex; gap: 8px; justify-content: flex-end;">
                                <a-button @click="closeNotificationModal">Cancelar</a-button>
                                <a-button type="primary" @click="emitNotification" :loading="notificationSubmitting">Emitir</a-button>
                            </div>
                        </a-form>
                    </template>
                    <!-- Barra de progresso: job em processamento -->
                    <template v-else-if="notificationView === 'progress'">
                        <div style="padding: 16px 0;">
                            <a-spin size="large" />
                            <p style="margin-top: 12px; margin-bottom: 8px;">Processando lote em segundo plano...</p>
                            <a-progress
                                :percent="notificationProgressPercent"
                                :status="notificationProgressPercent >= 100 ? 'success' : 'active'"
                            />
                            <p style="margin-top: 8px; font-weight: 500;">
                                {{ notificationProcessedCount }} de {{ notificationTotalCount }} processados
                                <span v-if="notificationTotalCount > 0" style="color: #888;">({{ notificationProgressPercent }}%)</span>
                            </p>
                            <p style="color: #888; font-size: 12px; margin-top: 8px;">Você pode fechar este modal e abri-lo novamente para ver o status.</p>
                            <a-button style="margin-top: 12px" @click="closeNotificationModal">Fechar</a-button>
                        </div>
                    </template>
                    <!-- Histórico: lotes já emitidos + opção emitir novamente -->
                    <template v-else-if="notificationView === 'history'">
                        <div v-if="notificationBatches.length === 0" style="padding: 12px 0;">
                            <p>Nenhum lote emitido ainda.</p>
                            <a-button type="primary" @click="notificationView = 'form'">Emitir lote</a-button>
                        </div>
                        <div v-else>
                            <a-list size="small" :data-source="notificationBatches">
                                <template #renderItem="{ item }">
                                    <a-list-item>
                                        <a-list-item-meta>
                                            <template #title>
                                                {{ item.descricao || 'Lote sem descrição' }}
                                                <a-tag :color="item.status === 'completed' ? 'green' : item.status === 'failed' ? 'red' : 'blue'" style="margin-left: 6px;">
                                                    {{ item.status === 'completed' ? 'Concluído' : item.status === 'failed' ? 'Falhou' : item.status === 'processing' ? 'Processando...' : 'Na fila' }}
                                                </a-tag>
                                            </template>
                                            <template #description>
                                                {{ new Date(item.created_at).toLocaleString('pt-BR') }}
                                                <span v-if="item.error_message" style="color: #c00;"> — {{ item.error_message }}</span>
                                            </template>
                                        </a-list-item-meta>
                                        <template #actions>
                                            <a v-if="item.status === 'completed'" href="#" @click.prevent="downloadNotificationBatch(item.id)" title="Baixar PDF">
                                                <DownloadOutlined style="font-size: 18px;" />
                                            </a>
                                        </template>
                                    </a-list-item>
                                </template>
                            </a-list>
                            <div style="margin-top: 16px; display: flex; gap: 8px;">
                                <a-button type="primary" @click="notificationView = 'form'; notificationDescription = ''">Emitir novamente</a-button>
                                <a-button @click="closeNotificationModal">Fechar</a-button>
                            </div>
                        </div>
                    </template>
                </a-modal>
            </div>
        </div>
    </div>
</template>

<script setup>
import 'ol/ol.css'
import 'ol-ext/dist/ol-ext.css'

import Map from 'ol/Map'
import View from 'ol/View'
import Select from 'ol/interaction/Select'
import GeoJSON from "ol/format/GeoJSON";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import { defaults as defaultControlsOL } from 'ol/control'
import { extend as extendExtent, getCenter } from 'ol/extent';
import {scaleLine} from '../../../../open-layers/default-controls.js'
import {
    getRegisteredLayers, getCustomLayers,
    getSubdivisionBuildingFeatureByCoordinate, getSubdivisionBuildingFeatureByPropertyId
} from "../../../../open-layers/map-helpers/home";

import {
    createLayer,
    getMapFeaturesByLayer,
    findLayerWithClickAction,
    findPrimaryClickLayer,
    removeSelectLayers,
    substituteAttributeTemplate,
    getLayerClickAction,
    isRasterMapsLayer,
    isPixelOnRasterLayer,
    collectPersonalizadoVectorLayers,
} from '../../../../open-layers/helpers.js'
import { toLonLat } from 'ol/proj'
import { geoJsonReadOptions } from '../../../../open-layers/projections.js'

import {
    selectSubdivisionStyle,
    selectBuildingStyle, defaultBuildingStyle, } from '../../../../open-layers/styles.js'

import {defineAsyncComponent, markRaw, onMounted, ref, computed, h, nextTick} from 'vue'
import HomeMapControls from './HomeMapControls.vue'
import ReturnToMobileApp from './ReturnToMobileApp.vue'

import {ModalsContainer, useModal} from "vue-final-modal";

const props = defineProps({
    user: { type: Object, required: true }
})
import Browser from "../../Components/Browser.vue";
import HtmlModalMap from "../Components/HtmlModalMap.vue";
import Style from "ol/style/Style";
import Stroke from "ol/style/Stroke";
import Fill from "ol/style/Fill";
import {notification, Button} from "ant-design-vue";
import GeneralMapControls from "../Components/GeneralMapControls.vue";
import HomeContextMenu from "../Components/HomeContextMenu.vue";
import UserLayersConfig from "./UserLayersConfig.vue";
import verifySpecificFuncPermissions from '../../../../utils/verifySpecificFuncPermissions'
import Photo from "ol-ext/style/Photo";
import Icon from "ol/style/Icon";
import {RegularShape} from "ol/style";
import {DownloadOutlined} from "@ant-design/icons-vue";
import MapLayerSwitcher from "../Components/MapLayerSwitcher.vue";
import { getDefaultMapView } from '../../../../open-layers/map-defaults.js';

const documentsSource = markRaw(new VectorSource())
const imagesSource = markRaw(new VectorSource())
const documentsClicked = ref([])
const imagesClicked = ref([])
const modalFilesOpen = ref(false)
const modalOpen = ref(false)
const mapFilesCarouselRef = ref(null)
const minHomeIconSize = 16
const maxHomeIconSize = 48
const homeIconSize = ref(32)
const geoCadastralWarning = ref({ show: false, message: '' })
const geoCadastralBlocked = computed(() => geoCadastralWarning.value.show)

const GEO_CADASTRAL_BLOCKED_MSG = 'Os dados cadastrais (lotes e edificações) não estão disponíveis. Ações de pesquisa, seleção e BIC foram desativadas.'

function notifyGeoCadastralBlocked() {
    notification.warning({
        message: 'Ação indisponível',
        description: GEO_CADASTRAL_BLOCKED_MSG,
        placement: 'bottomRight',
        key: 'geo-cadastral-blocked',
    })
}

const homeMapContainerStyle = computed(() => ({
    textAlign: 'center',
    position: 'relative',
    overflow: 'hidden',
    '--home-map-icon-size': `${homeIconSize.value}px`,
    '--home-map-icon-glyph-size': `${Math.round(homeIconSize.value * 0.5)}px`,
    '--home-map-icon-radius': `${Math.max(4, Math.round((homeIconSize.value / 32) * 6))}px`,
}))

async function loadHomeIconPersonalization() {
    try {
        const { data } = await window.axios.get('/api/configurations/personalizations')
        const value = Number(data?.data?.home_icon_size)
        if (Number.isFinite(value)) {
            homeIconSize.value = Math.min(maxHomeIconSize, Math.max(minHomeIconSize, value))
        }
    } catch (e) {
        // If personalization is unavailable, keep default icon size.
    }
}

async function loadGeoCadastralStatus() {
    try {
        const { data } = await window.axios.get('/api/maps/geo-cadastral-status')
        const payload = data?.data
        geoCadastralWarning.value = {
            show: Boolean(payload?.show_warning),
            message: payload?.message || '',
        }
    } catch (e) {
        geoCadastralWarning.value = { show: false, message: '' }
    }
}

function applyGeoCadastralBlockState() {
    if (geoCadastralBlocked.value) {
        clearBicSelection()
    }
}

const layerSwitcherData = ref(null)

async function addStreetVectorLayer(map) {
    const streetLayer = await createLayer({
        layer_type: 'VectorLayer',
        description: 'Ruas Vetor Home',
        active: true,
        display_in_layer_switcher: false,
        name: 'vector-street',
        zIndex: map.getLayers().getArray().length + 1,
        geo_table: 'public.geo_ruas',
        style: new Style({
            fill: new Fill({ color: 'transparent' })
        })
    })

    if (!streetLayer) return

    map.addLayer(streetLayer)
}

function mapFilePublicUrl(path) {
    if (!path) return ''
    if (path.startsWith('http://') || path.startsWith('https://')) return path
    return path.startsWith('/') ? path : `/${path}`
}

const mapModalFileItems = computed(() => {
    const items = []
    documentsClicked.value.forEach((f) => {
        items.push({
            name: f.get('name'),
            url: mapFilePublicUrl(f.get('path')),
        })
    })
    imagesClicked.value.forEach((f) => {
        items.push({
            name: f.get('name'),
            url: mapFilePublicUrl(f.get('path')),
        })
    })
    return items
})

const isMapFileImageUrl = (url = '') => /\.(png|jpg|jpeg|webp|gif)(\?|$)/i.test(url)
const isMapFilePdfUrl = (url = '') => /\.pdf(\?|$)/i.test(url)

const mapFileTypeLabel = (name = '') => {
    const ext = (name.split('.').pop() || '').toLowerCase()
    if (['png', 'jpg', 'jpeg', 'webp', 'gif'].includes(ext)) return 'Imagem'
    if (ext === 'pdf') return 'PDF'
    if (['doc', 'docx'].includes(ext)) return 'Documento'
    if (['xls', 'xlsx'].includes(ext)) return 'Planilha'
    if (ext === 'txt') return 'Texto'
    return 'Arquivo'
}

const openMapFileUrl = (url) => window.open(url, '_blank')

const mapFilesCarouselPrev = () => mapFilesCarouselRef.value?.prev?.()
const mapFilesCarouselNext = () => mapFilesCarouselRef.value?.next?.()

const onMapFilesModalAfterOpen = (open) => {
    if (!open) return
    nextTick(() => {
        mapFilesCarouselRef.value?.goTo?.(0, false)
    })
}
const activePopoverCoordinate = ref(null)
const swipePermission = ref(false)
const modalRef = ref('')
const mapRef = ref(null)
const currentSubdivisionPropertyId = ref()
const modalKey = ref(0)
const currentFaq = ref(null)
const browser = markRaw(Browser)
const height = 650
const width = 570
const top = (window.innerHeight - height) - ((window.innerHeight - height) / 2)
const left = (window.innerWidth - width) - ((window.innerWidth - width) / 2)
const isDrawing = ref(false)
const tooltip = ref(null)
let pointerMoveTimeout = null;

const blockTooltip = () => {
    tooltip.value.style.opacity = '0';
    clearTimeout(pointerMoveTimeout);
}

// Modal Lote de Notificações (camadas Multifinalitário)
const notificationModalOpen = ref(false)
const notificationDescription = ref('')
const notificationLayerRef = ref(null)
const notificationView = ref('form') // 'form' | 'progress' | 'history'
const notificationBatches = ref([])
const notificationSubmitting = ref(false)
const notificationPollingBatchId = ref(null)
let notificationPollingTimer = null

const notificationCurrentBatch = computed(() => {
    const id = notificationPollingBatchId.value
    if (!id) return null
    return notificationBatches.value.find(b => b.id === id) || null
})
const notificationTotalCount = computed(() => notificationCurrentBatch.value?.total_count ?? 0)
const notificationProcessedCount = computed(() => notificationCurrentBatch.value?.processed_count ?? 0)
const notificationProgressPercent = computed(() => {
    const total = notificationTotalCount.value
    if (total <= 0) return 0
    return Math.min(100, Math.round((notificationProcessedCount.value / total) * 100))
})

function getNotificationLayerId() {
    const ly = notificationLayerRef.value
    return ly?.get('layer_id') ?? ly?.get('id') ?? null
}

async function fetchNotificationBatches() {
    const layerId = getNotificationLayerId()
    if (layerId == null) return
    try {
        const { data } = await window.axios.get(`/api/docs/notifications/layer/${layerId}/batches`)
        notificationBatches.value = data.data || []
    } catch (_) {
        notificationBatches.value = []
    }
}

function chooseNotificationView() {
    const pendingOrProcessing = notificationBatches.value.find(b => b.status === 'pending' || b.status === 'processing')
    if (pendingOrProcessing) {
        notificationView.value = 'progress'
        notificationPollingBatchId.value = pendingOrProcessing.id
        startNotificationPolling()
        return
    }
    if (notificationBatches.value.some(b => b.status === 'completed')) {
        notificationView.value = 'history'
        return
    }
    notificationView.value = 'form'
}

function startNotificationPolling() {
    stopNotificationPolling()
    const poll = async () => {
        const id = notificationPollingBatchId.value
        if (!id) return
        try {
            const { data } = await window.axios.get(`/api/docs/notifications/batch/${id}`)
            const batch = data.data
            const idx = notificationBatches.value.findIndex(b => b.id === batch.id)
            if (idx >= 0) {
                notificationBatches.value[idx] = { ...notificationBatches.value[idx], ...batch }
            } else {
                notificationBatches.value = [batch, ...notificationBatches.value]
            }
            if (batch.status === 'completed' || batch.status === 'failed') {
                stopNotificationPolling()
                notificationPollingBatchId.value = null
                notificationView.value = 'history'
                if (batch.status === 'completed') {
                    notification.success({ message: 'Lote de notificações concluído. Baixe o PDF abaixo.', placement: 'bottomRight' })
                } else {
                    notification.error({ message: batch.error_message || 'Falha ao processar lote.', placement: 'bottomRight' })
                }
                return
            }
        } catch (_) {}
        notificationPollingTimer = setTimeout(poll, 2500)
    }
    poll()
}

function stopNotificationPolling() {
    if (notificationPollingTimer) {
        clearTimeout(notificationPollingTimer)
        notificationPollingTimer = null
    }
}

function onNotificationModalOpenChange(open) {
    if (open) {
        fetchNotificationBatches().then(() => chooseNotificationView())
    } else {
        stopNotificationPolling()
        notificationPollingBatchId.value = null
    }
}

const openNotificationModal = (layer) => {
    notificationLayerRef.value = layer
    notificationDescription.value = ''
    notificationModalOpen.value = true
    // Sempre buscar lotes e definir a view (progress/history/form) ao abrir, para exibir barra de progresso se houver lote em processamento
    fetchNotificationBatches().then(() => chooseNotificationView())
}

const closeNotificationModal = () => {
    notificationModalOpen.value = false
    notificationDescription.value = ''
    notificationLayerRef.value = null
    stopNotificationPolling()
    notificationPollingBatchId.value = null
    // Não limpar notificationBatches nem notificationView para que, ao reabrir, chooseNotificationView use os dados até a nova busca concluir
}

const emitNotification = async () => {
    const descricao = notificationDescription.value?.trim()
    if (!descricao) {
        notification.warning({ message: 'Informe a descrição do lote de notificações.', placement: 'bottomRight' })
        return
    }
    const layerId = getNotificationLayerId()
    if (layerId == null) {
        notification.warning({ message: 'Camada não identificada.', placement: 'bottomRight' })
        return
    }
    notificationSubmitting.value = true
    try {
        const { data } = await window.axios.post('/api/docs/notifications/emit-batch', { descricao, layer_id: layerId })
        if (data.error) {
            notification.error({ message: data.message ?? 'Erro ao iniciar emissão.', placement: 'bottomRight' })
            return
        }
        const batchId = data.data?.batch_id
        notificationBatches.value = [{ id: batchId, status: data.data?.status || 'pending', descricao, created_at: new Date().toISOString() }, ...notificationBatches.value]
        notificationView.value = 'progress'
        notificationPollingBatchId.value = batchId
        startNotificationPolling()
        notification.success({ message: 'Emissão em lote iniciada. Acompanhe o progresso.', placement: 'bottomRight' })
    } catch (err) {
        const msg = err.response?.data?.message ?? err.message ?? 'Erro ao emitir lote.'
        notification.error({ message: msg, placement: 'bottomRight' })
    } finally {
        notificationSubmitting.value = false
    }
}

async function downloadNotificationBatch(batchId) {
    try {
        const response = await window.axios.get(`/api/docs/notifications/batch/${batchId}/download`, { responseType: 'blob' })
        const url = window.URL.createObjectURL(response.data)
        const a = document.createElement('a')
        a.href = url
        a.download = `notificacoes-lote-${batchId}-${new Date().toISOString().slice(0, 10)}.pdf`
        document.body.appendChild(a)
        a.click()
        a.remove()
        window.URL.revokeObjectURL(url)
        notification.success({ message: 'Download iniciado.', placement: 'bottomRight' })
    } catch (_) {
        notification.error({ message: 'Erro ao baixar PDF.', placement: 'bottomRight' })
    }
}

const { open } = useModal({
    component: defineAsyncComponent(() => import('../../Components/ModalDragResize.vue')),
    attrs: {
        key: modalKey,
        component: browser,
        componentProps: {
            type: 'faq',
            id: currentFaq,
        },
        h: height,
        w: width,
        x: left,
        y: top,
        onClosed: () => {

        }
    }
})

const controls = ref({
    menu: {
        action: {
            name: '',
            attrs: {}
        }
    },
    search: {
        suggestions: []
    }
})

const styleCache = {}
const isCoordinateInsideLinkedGeometry = (feature, coordinate) => {
    const linkedGeometry = feature.get('linked_geometry')
    return linkedGeometry?.intersectsCoordinate?.(coordinate) === true
}

const documentsLayer = new VectorLayer({
    name: 'Documentos',
    displayInLayerSwitcher: false,
    visible: false,
    style: [new Style({
        image: new Icon({
            src: '/img/icone/maps/document.svg',
            scale: 1,
            displacement: [0, 15]
        })
    }),
        new Style({
            image: new RegularShape({
                points: 3,
                radius: 6,
                rotation: Math.PI,
                fill: new Fill({ color: '#1677ff' }),
                anchor: [0.5, 1],
            }),
        })
    ],
})
const imagesLayer = new VectorLayer({
    name: 'Imagens',
    displayInLayerSwitcher: false,
    visible: false,
    style: (feature) => {
        const src = feature.get('path')

        if (!styleCache[src]) {
            styleCache[src] = new Style({
                image: new Photo({
                    src,
                    radius: 15,
                    crop: true,
                    kind: 'square',
                    shadow: 5,
                    stroke: new Stroke({
                        color: '#1677ff',
                        width: 3
                    })
                }),
                zIndex: 10
            })
        }

        return styleCache[src]
    }
})

const openDetailsByFeatureTematic = (feature) => {
    if (!feature) {
        modalRef.value?.closePopover?.()
        activePopoverCoordinate.value = null
        return
    }
    const geometry = feature.getGeometry();
    if (!geometry) return;

    const extent = geometry.getExtent();
    const center = getCenter(extent);
    activePopoverCoordinate.value = center

    const pixel = mapRef.value.getPixelFromCoordinate(center)

    const reference = feature.get('reference');
    const allProps = feature.getProperties();
    const matricula = allProps.matricula ?? allProps.j01_matric ?? allProps.j39_matric;
    const matriculaNum = matricula != null && matricula !== '' ? Number(matricula) : null
    let props = {
        html: reference ? reference.replaceAll('\n', '<br/>') : null,
        ...(matriculaNum != null && !Number.isNaN(matriculaNum) ? { matricula: matriculaNum } : {})
    }

    modalRef.value?.openPopover?.(props, pixel)
}

const selectStreetById = async (streetId) => {
    const style = new  Style({
        stroke: new Stroke({ color: 'yellow', width: 7 }),
    });
    const features = (await getMapFeaturesByLayer('vector-street', mapRef.value)) ?? [];

    features.forEach(f => {
        if (f.get('selected')) {
            f.setStyle(new Style ({
                fill: new Fill({color: 'transparent'})
            }))
        }
    })

    const selected = features.filter(f => f.get('codigo_ecidade') === streetId);
    if (!selected.length) return;

    selected.forEach(ft => {
        ft.set('selected', true)
        ft.setStyle(style)
    })

    const view = mapRef.value.getView();
    const extent = selected.slice(1).reduce((accumulator, feature) => {
        return extendExtent(accumulator, feature.getGeometry().getExtent())
    }, selected[0].getGeometry().getExtent().slice())

    view.fit(extent, {
        padding: [200, 200, 200, 200],
        duration: 600,
    });
}

const getPropertyIdsList = async () => {
    return (await window.axios.get('api/maps/layers/property-ids')).data.data
}

const selectFeatureMapControlEvent = ref(() => {})

const selectFeature = async (param, map, click = true, options = {}) => {
    const features = (await getMapFeaturesByLayer('vector-street', map)) ?? []
    features.forEach(f => {
        if (f.get('selected')) {
            f.setStyle(new Style ({
                fill: new Fill({color: 'transparent'})
            }))
        }
    })

    const layer = findLayerWithClickAction(map)
    if (!layer) return

    const clickAction = getLayerClickAction(layer)

    if (clickAction === 'BIC') {
        if (geoCadastralBlocked.value) {
            notifyGeoCadastralBlocked()
            return
        }
        await bicAction(param, map, click, options)
        return
    }

    if (typeof clickAction === 'function') {
        clickAction()
    }
}

const openPersonalizadoPopover = (html, coordinate, map) => {
    if (!html?.trim()) {
        modalRef.value?.closePopover?.()
        activePopoverCoordinate.value = null
        return
    }
    activePopoverCoordinate.value = coordinate
    const pixel = map.getPixelFromCoordinate(coordinate)
    modalRef.value?.openPopover?.({ html: html.replaceAll('\n', '<br/>') }, pixel)
}

const handlePersonalizadoRasterClick = async (map, evt, targetLayer) => {
    if (!targetLayer) return false

    const layerId = targetLayer.get('id')
    const template = targetLayer.get('reference')
    if (!layerId || !template) return false

    const [lon, lat] = toLonLat(evt.coordinate, map.getView().getProjection())

    try {
        const { data: resp } = await window.axios.post(`/api/maps/layers/${layerId}/feature-at-point`, { lon, lat })
        const props = resp?.data
        if (!props || typeof props !== 'object') {
            modalRef.value?.closePopover?.()
            activePopoverCoordinate.value = null
            return false
        }
        openPersonalizadoPopover(substituteAttributeTemplate(template, props), evt.coordinate, map)
        return true
    } catch (e) {
        console.warn('Consulta Personalizado (raster) falhou:', e)
        return false
    }
}

const handlePersonalizadoVectorClick = async (map, evt, targetLayer) => {
    const vectorLayers = targetLayer.get?.('layer_type') === 'VectorLayer'
        ? [targetLayer]
        : collectPersonalizadoVectorLayers(targetLayer)

    if (!vectorLayers.length) return false

    let hitFeature = null
    let hitLayer = null

    map.forEachFeatureAtPixel(evt.pixel, (feature, layer) => {
        if (!vectorLayers.includes(layer)) return
        hitFeature = feature
        hitLayer = layer
        return true
    }, { hitTolerance: 5, layerFilter: (layer) => vectorLayers.includes(layer) })

    if (!hitFeature || !hitLayer) return false

    const template = hitLayer.get('reference') || ''
    const layerId = hitLayer.get('id')
    const gid = Number(hitFeature.get('gid'))

    if (layerId && template && Number.isFinite(gid) && gid >= 1) {
        try {
            const { data: resp } = await window.axios.post(
                `/api/maps/layers/${layerId}/feature-by-gid`,
                { gid }
            )
            const props = resp?.data
            if (props && typeof props === 'object') {
                const geom = hitFeature.getGeometry()
                const center = geom ? getCenter(geom.getExtent()) : evt.coordinate
                openPersonalizadoPopover(substituteAttributeTemplate(template, props), center, map)
                return true
            }
        } catch (e) {
            console.warn('Consulta Personalizado (vetor) falhou:', e)
        }
    }

    const props = { ...hitFeature.getProperties() }
    delete props.geometry
    const html = substituteAttributeTemplate(template, props)
    if (html?.trim()) {
        const geom = hitFeature.getGeometry()
        const center = geom ? getCenter(geom.getExtent()) : evt.coordinate
        openPersonalizadoPopover(html, center, map)
        return true
    }

    return false
}

const handlePrimaryLayerClick = async (map, evt) => {
    const layer = findPrimaryClickLayer(map)
    if (!layer) return

    const action = getLayerClickAction(layer)

    if (action === 'Personalizado') {
        if (isRasterMapsLayer(layer)) {
            if (!isPixelOnRasterLayer(layer, evt.pixel)) return
            await handlePersonalizadoRasterClick(map, evt, layer)
            return
        }
        await handlePersonalizadoVectorClick(map, evt, layer)
        return
    }

    if (action === 'BIC') {
        if (geoCadastralBlocked.value) {
            notifyGeoCadastralBlocked()
            return
        }
        await bicAction(evt.coordinate, map, true)
    }
}

const bicSelectInteractionRef = ref(null)

const bicAction = async (param, map, click, options = {}) => {
    if (geoCadastralBlocked.value) {
        notifyGeoCadastralBlocked()
        return
    }
    if (isDrawing.value) return
    let subdivisions, buildings;

    if (Array.isArray(param)) {
        ({ subdivisions, buildings } = await getSubdivisionBuildingFeatureByCoordinate(param));
    } else {
        ({ subdivisions, buildings } = await getSubdivisionBuildingFeatureByPropertyId(param));
    }

    let subdivisionPropertyId = subdivisions.features?.[0]?.properties?.propertyId;

    if (subdivisionPropertyId === currentSubdivisionPropertyId.value) {
        if (!click) {
            let buildingsArr = await getMapFeaturesByLayer('select-buildings', map)
            ;(buildingsArr ?? []).forEach(ft => {
                ft.setStyle(defaultBuildingStyle)
                if (ft.get('propertyId') === param) {
                    ft.setStyle(selectBuildingStyle)
                    if (options.syncControls !== false) {
                        controls.value.menu.action.name = 'bic';
                        controls.value.menu.action.attrs = {
                            propertyId: ft.get('propertyId'),
                            searchSelect: true,
                            subdivisionPropertyId: subdivisionPropertyId,
                            bicSelectionKey: controls.value.menu.action.attrs?.bicSelectionKey ?? 0,
                        };
                    }
                }
            })
        }

        return
    }

    currentSubdivisionPropertyId.value = subdivisionPropertyId
    if (bicSelectInteractionRef.value) {
        map.removeInteraction(bicSelectInteractionRef.value)
        bicSelectInteractionRef.value = null
    }
    removeSelectLayers(map)

    const mapZIndex = map.getLayers().getArray().length

    const subdivisionSelectLayer = new VectorLayer({
        source: new VectorSource(),
        style: selectSubdivisionStyle,
        displayInLayerSwitcher: false,
        layerName: 'select-subdivision',
        zIndex: mapZIndex + 1
    })
    const buildingSelectLayer = new VectorLayer({
        source: new VectorSource(),
        style: defaultBuildingStyle,
        displayInLayerSwitcher: false,
        layerName: 'select-buildings',
        zIndex: mapZIndex + 2
    })

    const selectInteraction = new Select({ layers: [buildingSelectLayer] });
    map.addLayer(subdivisionSelectLayer)
    map.addLayer(buildingSelectLayer)

    selectInteraction.on('select', (event) => {
        const feature = event.selected[0];
        if (!feature) return;
        let blds = getMapFeaturesByLayer('select-buildings', map)
        ;(blds ?? []).forEach(ft => {
            ft.setStyle(defaultBuildingStyle)
            if (ft.get('propertyId') === feature.get('propertyId')) {
                ft.setStyle(selectBuildingStyle)
            }
        })

        controls.value.menu.action.name = 'bic';
        controls.value.menu.action.attrs = {
            propertyId: feature.get('propertyId'),
            searchSelect: true,
            subdivisionPropertyId: subdivisionPropertyId
        };
    });

    bicSelectInteractionRef.value = selectInteraction
    map.addInteraction(selectInteraction);

    subdivisionSelectLayer.getSource().clear()
    buildingSelectLayer.getSource().clear()

    const format = new GeoJSON()
    const readOpts = geoJsonReadOptions(map.getView().getProjection())
    const subdivFeatures = format.readFeatures(subdivisions, readOpts)
    subdivisionSelectLayer.getSource().addFeatures(subdivFeatures)

    const buildFeatures = format.readFeatures(buildings, readOpts)

    buildFeatures.forEach(ft => {
        let matchPropertyId = click ? subdivisionPropertyId : param
        ft.setStyle(defaultBuildingStyle)

        if (ft.get('propertyId') === matchPropertyId) {
            ft.setStyle(selectBuildingStyle)
        }
    })
    buildingSelectLayer.getSource().addFeatures(buildFeatures)
    const allFeatures = [...subdivFeatures, ...buildFeatures]

    if (!allFeatures.length) {
        return;
    }

    if(!click) {
        const view = map.getView();
        const center = getCenter(allFeatures[0].getGeometry().getExtent());
        view.setZoom(18);
        view.setCenter(center);
    }

    controls.value.menu.action.name = 'bic';
    controls.value.menu.action.attrs = {
        propertyId: !click ? param : allFeatures[0].get('propertyId'),
        searchSelect: !click,
        subdivisionPropertyId: subdivisionPropertyId
    };
}

const closePopover = () => {
    //
}

function syncBicPanelControls(propertyId) {
    const normalizedId = Number(propertyId)
    const attrs = controls.value.menu.action.attrs ?? {}
    controls.value.menu.action.name = 'bic'
    controls.value.menu.action.attrs = {
        propertyId: Number.isFinite(normalizedId) ? normalizedId : propertyId,
        searchSelect: true,
        subdivisionPropertyId: attrs.subdivisionPropertyId ?? currentSubdivisionPropertyId.value,
        bicSelectionKey: (attrs.bicSelectionKey ?? 0) + 1,
    }
}

function clearBicSelection() {
    const map = mapRef.value
    if (!map) return
    if (bicSelectInteractionRef.value) {
        map.removeInteraction(bicSelectInteractionRef.value)
        bicSelectInteractionRef.value = null
    }
    removeSelectLayers(map)
    currentSubdivisionPropertyId.value = null
    controls.value.menu.action.name = ''
    controls.value.menu.action.attrs = {}
}

onMounted(async () => {
    await loadHomeIconPersonalization()
    await loadGeoCadastralStatus()

    const map = new Map({
        target: 'map',
        layers: [],
        view: new View(getDefaultMapView()),
        controls: defaultControlsOL({ rotate: false, zoom: false }).extend([scaleLine])
    });

    // Atribui IDs às camadas de base: 'b-{index}'
    const baseLayersGroup = map.getLayers().getArray().find(layer => 
        layer.get('title') === 'Camadas de Base' || layer.getLayers
    );
    if (baseLayersGroup && baseLayersGroup.getLayers) {
        const baseLayersArray = baseLayersGroup.getLayers().getArray();
        baseLayersArray.forEach((layer, index) => {
            layer.set('id', `b-${index}`);
        });
    }

    if (!geoCadastralBlocked.value) {
        controls.value.search.suggestions = await getPropertyIdsList()
    }

    // Adiciona as camadas registradas primeiro (aguarda carregamento completo)
    const registeredVectorLayersWithTemplate = []
    try {
        const registeredLayers = await getRegisteredLayers('Home');
        (registeredLayers ?? []).forEach(layer => {
            // Verifica se a camada é válida e tem nome/título antes de adicionar
            // LayerGroups usam 'title', outras camadas usam 'name'
            const layerName = layer.get('name');
            const layerTitle = layer.get('title');
            const isLayerGroup = layer.getLayers && typeof layer.getLayers === 'function';

            if (!layer) {
                console.warn('Camada inválida ignorada:', layer);
                return;
            }

            // Para LayerGroups, verifica se tem título e se não está vazio
            if (isLayerGroup) {
                if (!layerTitle) {
                    console.warn('LayerGroup sem título ignorado:', layer);
                    return;
                }
                const groupLayers = layer.getLayers().getArray();
                if (groupLayers.length === 0) {
                    console.warn('LayerGroup vazio ignorado:', layerTitle);
                    return;
                }
            } else {
                // Para outras camadas, verifica se tem nome
                if (!layerName) {
                    console.warn('Camada sem nome ignorada:', layer);
                    return;
                }
            }

            let actions = layer.get('actions') || {}
            const faqId = layer.get('faq_id')

            if (!!faqId) {
                actions.faq = () => {
                    currentFaq.value = faqId
                    open()
                }
            } else {
                actions.faq = null
            }

            actions.notification = () => openNotificationModal(layer)

            layer.set('actions', actions);
            map.addLayer(layer);

            collectPersonalizadoVectorLayers(layer, registeredVectorLayersWithTemplate)
        })
    } catch (error) {
        console.error('Erro ao carregar camadas registradas:', error);
    }

    if (registeredVectorLayersWithTemplate.length > 0) {
        const selectRegistered = new Select({ layers: registeredVectorLayersWithTemplate })
        selectRegistered.on('select', async (event) => {
            const feature = event.selected?.[0] ?? null
            if (!feature) {
                modalRef.value?.closePopover?.()
                activePopoverCoordinate.value = null
                return
            }

            const layer = selectRegistered.getLayer(feature)
            const template = layer?.get('reference') || ''
            const layerId = layer?.get('id')
            const gid = Number(feature.get('gid'))

            if (layerId && template && Number.isFinite(gid) && gid >= 1) {
                try {
                    const { data: resp } = await window.axios.post(
                        `/api/maps/layers/${layerId}/feature-by-gid`,
                        { gid }
                    )
                    const props = resp?.data
                    if (props && typeof props === 'object') {
                        const geom = feature.getGeometry()
                        const center = geom ? getCenter(geom.getExtent()) : map.getView().getCenter()
                        openPersonalizadoPopover(substituteAttributeTemplate(template, props), center, map)
                        return
                    }
                } catch (e) {
                    console.warn('Consulta Personalizado (vetor) falhou:', e)
                }
            }

            let props = feature.getProperties()
            delete props.geometry
            feature.set('reference', substituteAttributeTemplate(template, props))
            openDetailsByFeatureTematic(feature)
        })
        map.addInteraction(selectRegistered)
    }

    // Adiciona o grupo Multifinalitário por último (aparece primeiro no layer switcher)
    // Aguarda as camadas registradas carregarem primeiro
    try {
        const customLayerGroup = await getCustomLayers();

        // Sempre adiciona o grupo, mesmo que vazio
        map.addLayer(customLayerGroup)

        // Verifica se o grupo tem layers válidas para adicionar interação
        const groupLayers = customLayerGroup.getLayers().getArray();
        if (groupLayers.length > 0) {
            let allLayers = []
            groupLayers.forEach(ly => {
                // Verifica se a camada é válida e tem nome antes de adicionar
                if (!ly || !ly.get('name')) {
                    console.warn('Camada temática inválida ou sem nome ignorada:', ly);
                    return;
                }

                allLayers.push(ly)
                let actions = ly.get('actions') || {}
                const faqId = ly.get('faq_id')

                if (!!faqId) {
                    actions.faq = () => {
                        currentFaq.value = faqId
                        open()
                    }
                } else {
                    actions.faq = null
                }

                const layerMap = ly.get('geo_table')
                const name = ly.get('name')

                actions.export = () => openNotification(layerMap, name)
                actions.notification = () => openNotificationModal(ly)

                ly.set('actions', actions);
            })

            // Só adiciona a interação se houver layers válidas
            if (allLayers.length > 0) {
                const selectInteraction = new Select({ layers: allLayers });
                selectInteraction.on('select', (event) => {
                    const feature = event.selected?.[0] ?? null;
                    if (!feature) return;

                    let props = feature.getProperties();
                    delete props.geometry;

                    const layer = event.target.getLayer(feature);
                    const template = layer?.get('reference') || '';

                    const reference = template.replace(/\$([a-zA-Z0-9_]+)/g, (match, key) => {
                        return props[key] ?? '';
                    });
                    feature.set('reference', reference);

                    openDetailsByFeatureTematic(feature);
                });

                map.addInteraction(selectInteraction)
            }
        }
    } catch (error) {
        console.error('Erro ao carregar camadas customizadas:', error);
    }

    await addStreetVectorLayer(map)

    selectFeatureMapControlEvent.value = async (e) => {
        const { propertyId, searchSelect, searchType, streetId } = e;

        if (!searchType && propertyId) {
            if (geoCadastralBlocked.value) {
                notifyGeoCadastralBlocked()
                return
            }
            await selectFeature(propertyId, map, false, { syncControls: false })
            syncBicPanelControls(propertyId)
            return
        }

        if (geoCadastralBlocked.value) {
            const needsCadastral = ['owner', 'propertyId', 'sql'].includes(searchType)
                || (searchType === 'address' && propertyId)
            if (needsCadastral) {
                notifyGeoCadastralBlocked()
                return
            }
        }

        switch (searchType) {
            case 'owner':
            case 'propertyId':
            case 'sql':
                selectFeature(propertyId, map, !searchSelect)
                break;
            case 'address':
                if (propertyId) {
                    selectFeature(propertyId, map, !searchSelect)
                } else {
                    selectStreetById(streetId)
                }
                break;
        }

    };

    map.on('singleclick', async (evt) => {
        documentsClicked.value = []
        imagesClicked.value = []

        // Regra principal: exibir anexos cuja geometria vinculada contém o ponto clicado.
        documentsClicked.value = documentsSource
            .getFeatures()
            .filter(feature => isCoordinateInsideLinkedGeometry(feature, evt.coordinate))

        imagesClicked.value = imagesSource
            .getFeatures()
            .filter(feature => isCoordinateInsideLinkedGeometry(feature, evt.coordinate))

        // Fallback: mantém clique direto no ícone do anexo.
        if (!documentsClicked.value.length && !imagesClicked.value.length) {
            map.forEachFeatureAtPixel(evt.pixel, (feature) => {
                if (feature.get('type') === 'document') {
                    documentsClicked.value.push(feature)
                } else if (feature.get('type') === 'image') {
                    imagesClicked.value.push(feature)
                }
            }, {
                hitTolerance: 10
            })
        }

        if (documentsClicked.value.length || imagesClicked.value.length) modalFilesOpen.value = true

        try {
            await handlePrimaryLayerClick(map, evt)
        } catch (e) {
            console.warn('Clique no mapa falhou:', e)
        }
    });

    map.on('moveend', () => {
        if (activePopoverCoordinate?.value && modalRef?.value?.updatePopoverPosition) {
            const pixel = map.getPixelFromCoordinate(activePopoverCoordinate.value)
            modalRef.value.updatePopoverPosition(pixel)
        }
    })

    map.on('pointermove', (evt) => {
        if (evt.dragging) return

        tooltip.value.style.opacity = '0'
        clearTimeout(pointerMoveTimeout)

        pointerMoveTimeout = setTimeout(() => {
            if (geoCadastralBlocked.value) {
                return
            }
            window.axios.get(`api/maps/layers/lot-layer/${evt.coordinate}`)
                .then(response => {
                    const lote = response.data.data

                    if (lote) {
                        if (evt.originalEvent.clientX + tooltip.value.offsetWidth > window.innerWidth) {
                            tooltip.value.style.left = `${evt.originalEvent.clientX - tooltip.value.offsetWidth - 20}px`
                        } else {
                            tooltip.value.style.left = `${evt.originalEvent.clientX}px`
                        }

                        tooltip.value.style.top = `${evt.originalEvent.clientY - 50}px`
                        tooltip.value.innerHTML =
                            `<strong>M: ${lote.matricula} (${lote.totalMatriculas})<br />
                             S: ${lote.setor} <br />
                             Q: ${lote.quadra} <br />
                             L: ${lote.lote}</strong>`
                        tooltip.value.style.opacity = '1'
                    } else {
                        tooltip.value.style.opacity = '0'
                    }
                })
        }, 300)
    })

    swipePermission.value = await verifySpecificFuncPermissions(3)
    await loadFileLayers()
    map.addLayer(documentsLayer)
    map.addLayer(imagesLayer)
    mapRef.value = map
    applyGeoCadastralBlockState()
});

const openNotification = (layerMap, name) => {
    const key = `export-notif-${Date.now()}`;
    const key2 = `export-notif-2-${Date.now()}`;

    notification.open({
        key,
        placement: "bottomRight",
        duration: 0,
        message: `Qual formato deseja exportar?`,
        description: () =>
            h(
                "div",
                {},
                [
                    h("div", { style: "margin: 4px; font-weight: bold;" }, `${name}`),
                    h(Button, { style: "margin: 4px", onClick: async () => {
                            await handleNotifications(key, key2, layerMap, name, 'txt')
                        }}, () => ".txt"),
                    h(Button, { style: "margin: 4px", onClick: async () => {
                            await handleNotifications(key, key2, layerMap, name, 'json')
                        }}, () => ".json"),
                    h(Button, { style: "margin: 4px", onClick: async () => {
                            await handleNotifications(key, key2, layerMap, name, 'xls')
                        }}, () => ".xls"),
                    h(Button, { style: "margin: 4px", onClick: async () => {
                            await handleNotifications(key, key2, layerMap, name, 'csv')
                        }}, () => ".csv"),
                ]
            ),
    });
};

const handleNotifications = async (key, key2, layerMap, name, format) => {
    notification.close(key)
    notification.open({
        key: key2,
        placement: 'bottomRight',
        duration: 30,
        message: 'Aguarde...',
        description: 'Estamos exportando seu mapa...',
        type: 'success',
    });
    const blob = await (await fetch(`/api/maps/export/${layerMap}?format=${format}`)).blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${name}.${format}`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
    notification.close(key2)
}

const loadFileLayers = async () => {
    documentsSource.clear()
    imagesSource.clear()

    const data = (await window.axios.get('/api/map-actions/layers/file/points')).data.data

    data.documents.forEach((document) => {
        const linkedGeometry = document.feature_geom
            ? new GeoJSON().readGeometry(JSON.parse(document.feature_geom), geoJsonReadOptions())
            : null
        const feature = new GeoJSON().readFeature(
            {
                type: 'Feature',
                geometry: JSON.parse(document.geom),
                properties: {
                    id: document.id,
                    name: document.name,
                    path: document.path,
                    type: 'document',
                    layer_id: document.layer_id,
                    geometry_gid: document.geometry_gid
                }
            },
            geoJsonReadOptions()
        )
        feature.set('linked_geometry', linkedGeometry)
        documentsSource.addFeature(feature)
    })
    documentsLayer.setSource(documentsSource)

    data.images.forEach(image => {
        const linkedGeometry = image.feature_geom
            ? new GeoJSON().readGeometry(JSON.parse(image.feature_geom), geoJsonReadOptions())
            : null
        const feature = new GeoJSON().readFeature(
            {
                type: 'Feature',
                geometry: JSON.parse(image.geom),
                properties: {
                    id: image.id,
                    name: image.name,
                    path: image.path,
                    type: 'image',
                    layer_id: image.layer_id,
                    geometry_gid: image.geometry_gid
                }
            },
            geoJsonReadOptions()
        )
        feature.set('linked_geometry', linkedGeometry)
        imagesSource.addFeature(feature)
    })
    imagesLayer.setSource(imagesSource)
}

</script>

<style scoped>
.map {
    width: 100%;
    height: 100vh;
    min-height: 100vh;
}
::v-deep(.ol-zoom) {
    position: absolute;
    right: 10px;
    left: auto !important;
    z-index: 1000;
}
::v-deep(.ol-layerswitcher) {
    position: absolute;
    top: 22px;
    right: 8px;
}

.info-button {
    color: blue;
    font-weight: bold;
}

.alert-button {
    color: red;
    font-weight: bold;
}

/* Pesquisa logo abaixo do menu flutuante */
.map-search {
    position: absolute;
    display: flex;
    flex-direction: column;
    gap: 8px;
    top: calc(
        8px +
        var(--home-map-icon-size, 32px) +
        max(8px, calc(var(--home-map-icon-size, 32px) * 0.25)) +
        calc(var(--home-map-icon-size, 32px) * 0.9)
    );
    left: 8px;
    z-index: 1000;
}

.map-geo-cadastral-warning {
    max-width: min(420px, calc(100vw - 32px));
    text-align: left;
}

.map-layer-switch {
    position: absolute;
    gap: 8px;
    top: 30px;
    right: 8px;
    z-index: 1000;
}

/* Ferramentas no canto inferior esquerdo */
.map-controls {
    position: absolute;
    display: flex;
    flex-direction: column;
    gap: 16px;
    bottom: 20px;
    left: 8px;
    z-index: 1000;
}

.user-layers-config {
    position: absolute;
    bottom: 20px;
    right: 8px;
    z-index: 1000;
    overflow: visible;
}

.map-tooltip {
    position: absolute;
    background: rgba(0, 0, 0, 0.75);
    color: white;
    padding: 6px 10px;
    font-size: 12px;
    border-radius: 4px;
    pointer-events: none;
    white-space: nowrap;
    transform: translate(10px, -20px);
    z-index: 1000;
    opacity: 0;
}

.map-files-carousel-wrap {
    margin-top: 4px;
}

.map-files-carousel-inner {
    display: flex;
    align-items: center;
    gap: 6px;
}

.map-files-carousel {
    flex: 1;
    width: 100%;
    min-height: 380px;
    max-height: 72vh;
    background: #f7f7f7;
    border-radius: 8px;
    padding: 8px;
    overflow: hidden;
}

.map-files-slide-inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    min-height: 320px;
    max-height: 65vh;
}

.map-files-preview-img {
    max-width: 100%;
    max-height: 58vh;
    object-fit: contain;
    border-radius: 6px;
}

.map-files-preview-pdf {
    width: 100%;
    height: 58vh;
    min-height: 280px;
    border: none;
    border-radius: 6px;
}

.map-files-file-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
}

.map-files-file-icon {
    font-size: 42px;
    color: #1677ff;
}

.map-files-file-type {
    color: #555;
    font-size: 14px;
}

.map-files-slide-actions {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 8px;
}

.map-files-slide-caption {
    text-align: center;
    color: #555;
    font-size: 12px;
    margin-top: 4px;
}

.map-files-carousel-arrow {
    color: #1677ff;
    flex-shrink: 0;
}

.map-files-empty {
    color: #888;
    text-align: center;
    padding: 12px;
}
</style>
